import {
  eachDayOfInterval,
  endOfMonth,
  format,
  isAfter,
  isBefore,
  parseISO,
  startOfMonth,
} from "date-fns";

import { DayObject } from "../../Calendar/types";

export const getDateInfoMap = (
  selectedDates: {
    startDate: string | null;
    endDate: string | null;
  },
  firstMonthObject: Date,
  nextMonthObj: Date
): Map<string, DayObject> => {
  const dateInfo = new Map<string, DayObject>();

  if (!selectedDates.startDate) {
    return dateInfo;
  }

  const fullRangeDates = eachDayOfInterval({
    start: startOfMonth(firstMonthObject),
    end: endOfMonth(nextMonthObj),
  });

  const startDate = parseISO(selectedDates.startDate);

  if (!selectedDates.endDate) {
    fullRangeDates.forEach((date) => {
      const formattedDate = format(date, "yyyy-MM-dd");

      if (formattedDate === format(startDate, "yyyy-MM-dd")) {
        dateInfo.set(formattedDate, { selected: true });
      } else {
        dateInfo.set(formattedDate, { status: "Default" });
      }
    });

    // Ensure startDate is always included even if outside the range,
    // so hover InRange highlighting is handled properly
    const startFormattedDate = format(startDate, "yyyy-MM-dd");
    if (!dateInfo.has(startFormattedDate)) {
      dateInfo.set(startFormattedDate, { selected: true });
    }

    return dateInfo;
  }

  const endDate = parseISO(selectedDates.endDate);

  fullRangeDates.forEach((date) => {
    const formattedDate = format(date, "yyyy-MM-dd");

    if (isBefore(date, startDate) || isAfter(date, endDate)) {
      dateInfo.set(formattedDate, { status: "Default" });
    } else {
      if (
        formattedDate === format(startDate, "yyyy-MM-dd") ||
        formattedDate === format(endDate, "yyyy-MM-dd")
      ) {
        dateInfo.set(formattedDate, { selected: true });
      } else {
        dateInfo.set(formattedDate, { status: "InRange" });
      }
    }
  });

  // Ensure startDate and endDate are always included even if outside the range,
  // so InRange highlighting is handled properly
  const startFormattedDate = format(startDate, "yyyy-MM-dd");
  const endFormattedDate = format(endDate, "yyyy-MM-dd");

  if (!dateInfo.has(startFormattedDate)) {
    dateInfo.set(startFormattedDate, { selected: true });
  }

  if (!dateInfo.has(endFormattedDate)) {
    dateInfo.set(endFormattedDate, { selected: true });
  }

  return dateInfo;
};
